import React from 'react';

import { Box, Text, ToggleTip } from '@betterment/samba-react';

import { trackClick } from '../../../../features/track';
import { formatReturn, formatReturnColor } from '../../../shared/utils';

type TimeWeightedReturnDisplayProps = {
  color: string;
  label: string;
  returnValue: number | null | undefined;
  displayDate: string | undefined;
  description?: string;
};

const handlePortfolioToolTipOpen = (open: boolean) => {
  if (open) {
    trackClick({
      name: 'portfolioToolTip',
      module: 'Performance',
      location: 'TimeWeightedReturns',
    });
  }
};

export const TimeWeightedReturnDisplay: React.FC<TimeWeightedReturnDisplayProps> = ({
  color,
  label,
  returnValue,
  displayDate,
  description,
}) => (
  <Box css={{ flex: 1 }}>
    <Box css={{ display: 'flex', alignItems: 'center', mb: 'space.50' }}>
      <Box
        css={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: color,
          mr: 'space.100',
        }}
      />
      <Text variant="text50" css={{ mr: 'space.50' }}>
        {label}
      </Text>
      {description && (
        <ToggleTip onOpenChange={handlePortfolioToolTipOpen}>
          <ToggleTip.Trigger label="Portfolio Strategy Information" css={{ alignSelf: 'self-start' }} />
          <ToggleTip.Content align="start" side="right" css={{ maxWidth: '300px', width: 'max-content' }}>
            Your current portfolio strategy is <br />
            {description}
          </ToggleTip.Content>
        </ToggleTip>
      )}
    </Box>
    <Box css={{ display: 'flex', flexDirection: 'column' }}>
      <Text variant="text300" css={{ color: formatReturnColor(returnValue) }}>
        {formatReturn(returnValue)}
      </Text>
      <Text variant="text50" css={{ color: 'text.secondary' }}>
        {displayDate || '\u00A0'}
      </Text>
    </Box>
  </Box>
);
